const TableRowChild = (props: any) => {
	const {tableRowChild, row, headers, extraProps} = props;
	return <>{tableRowChild && tableRowChild(row)}</>;
};

export default TableRowChild;
